import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RfqSessionSupplier } from 'src/app/shared/models';

@Component({
	selector: 'pk-broker-pricing-session-supplier-notes-view',
	standalone: false,
	templateUrl: './pricing-session-supplier-notes-view.component.html',
	styleUrl: './pricing-session-supplier-notes-view.component.scss',
})
export class PricingSessionSupplierNotesViewComponent {
	@Input() rfqSessionSuppliers: RfqSessionSupplier[] = [];

	@Output() editNote: EventEmitter<{ rfqSessionSupplier: RfqSessionSupplier; noteKey: string }> = new EventEmitter<{
		rfqSessionSupplier: RfqSessionSupplier;
		noteKey: string;
	}>();
}
